import Bind from 'bind.js';
import notification from 'notification-js';
import Validator from 'validator';
import Config from 'config';

export default class Form {
  constructor(data) {
    this.type = data.type;
    this.post = data.post;
  }

  getTemplate() {
    let formDiv = document.createElement('div');

    if (this.type === "contact-us") {
      formDiv.innerHTML = this.getContactForm();
    }

    return formDiv;
  }

  registerCallback() {
    if (this.type === "contact-us") {
      let form = document.getElementsByClassName(this.type + "-form")[0];
      let submit = form.getElementsByClassName('submit')[0];
      form.onsubmit = (event) => {
        event.preventDefault();

        if (this.validateContactForm(form)) {
          let name = form.getElementsByClassName('name')[0];
          let email = form.getElementsByClassName('email')[0];
          let message = form.getElementsByClassName('message')[0];

          var request = new XMLHttpRequest();

          request.onreadystatechange = function() {
            if (request.readyState == 4) {
              if (request.status == 200) {
                notification.notify( 'success', 'Enquiry has been submitted one of our team member will get back to you shortly.', {
                  notification: {position: [ 'right', 'top' ]}
                });
              } else {
                notification.notify( 'error', 'Their was an error submitting your enquiry please try again or give us a call.', {
                  notification: {position: [ 'right', 'top' ]}
                });
              }
            }
          };

          var data = {
            name: name.value,
            email: email.value,
            message: message.value
          }

          request.open("POST", Config.BACKEND_URL + this.post);
          request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
          request.send(JSON.stringify(data));
        }

        return false;
      }

    }
  }

  getContactForm() {
    return `
      <form method="post" class="${this.type}-form">
        <input type="text" name="name" placeholder="Name" class="name"/>
        <input type="text" class="email floatright"  name="email" placeholder="Email"/>
        <textarea name="message" placeholder="Message" class="message"></textarea>

        <input type="submit" name="submit" class='submit' value="Submit" />
      </form>
    `
  }

  validateContactForm(form) {
    let name = form.getElementsByClassName('name')[0];
    let email = form.getElementsByClassName('email')[0];
    let message = form.getElementsByClassName('message')[0];

    if (Validator.isNull(name.value) ||
        Validator.isNull(email.value) ||
        Validator.isNull(message.value)) {
      notification.notify( 'error', 'Please make sure all fields are entered', {
        notification: {position: [ 'right', 'top' ]}
      });
      return false;
    }

    if (!Validator.isEmail(email.value)) {
      notification.notify( 'error', 'Please enter a valid email address', {
        notification: {position: [ 'right', 'top' ]}
      });

      email.focus();
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/renderers/Form.js